export const updateProperty = <T>(match: boolean, data: T, append: Partial<T>): T => {
  if (match) {
    return {
      ...data,
      ...append
    };
  }
  return data;
};
